import { Component } from '@angular/core';
import { QuestionService } from '../../services/question.service';
import { NgFor, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-exams-view',
  standalone: true,
  imports: [NgIf, NgFor, RouterLink],
  templateUrl: './exams-view.component.html',
  styleUrl: './exams-view.component.scss'
})
export class ExamsViewComponent {
  exams: any[] = [];
  isLoading: boolean = true;

  constructor ( private questionService:QuestionService){}

  ngOnInit(){
    this.loadExams();
}

  loadExams() {
    this.questionService.getExams().subscribe(
      (data) => {
        this.exams = data[0]; 
        this.isLoading = false;
      },
      (error) => {
        console.error('Erro ao carregar os simulados:', error);
        this.isLoading = false;
      }
    );
  }
}
